export default __webpack_public_path__ + "static/media/useRecorder.54a9fff5.txt";